import React from "react";
import "./heading.css";
import $ from "jquery";
import RevealOnScroll from "../../components/revealOnScroll/revealOnScroll";

class Heading extends React.Component {
  componentDidMount() {
    $(document).ready(RevealOnScroll);
    $(window).on("scroll", RevealOnScroll);
  }

  render() {
    const { level, className, style, dangerouslySetInnerHTML, children } =
      this.props;
    const Heading = "h" + level;
    return (
      <Heading
        dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        className={className}
        style={style}
      >
        {children}
      </Heading>
    );
  }
}

export default Heading;
